<template>
  <div class="itemsRow d-flex" :class="{section:isSection}">
    <v-list-item
      :key="item.id"
      @click.passive="clickBox(item, $event)"
      style="flex-grow: 2"
    >
      <!--            <v-list-item-avatar tile :size="105" v-if="imgSource.length > 0">-->
      <!--                <v-img :src="imgSource" contain @click.native.stop="fullImageSrc = imgSource"></v-img>-->
      <!--                <div class="stoerer abs" v-if="item.neu">NEU</div>-->
      <!--            </v-list-item-avatar>-->

      <v-list-item-content v-if="item.section">
        <!--                <div class="spacer-15"></div>-->
        <div class="isection d-flex">
          <div class="prefix" v-if="item.sectionContent.indexOf('data-prefix') !== -1">
            <v-icon x-large class="myAccent mr-1">mdi-star</v-icon>
          </div>
          <div class="fontColor" style="align-self: center;"
               :class="{styled:item.sectionContent.indexOf('<') !== -1}" v-html="item.sectionContent"></div>
        </div>
      </v-list-item-content>

      <v-list-item-content v-else>
        <div class="d-flex">
          <div class="prelative tileImgCol"
               :class="{withImage: imgSource.length > 0 && (imgSource.indexOf('placeholder6') === -1 || $store.state.showPlaceholders)}">
            <!--                  left side-->
            <div v-if="imgSource.length === 0">
              <!--              <div class="stoerer mb-1" v-if="item.neu">NEU</div>-->
            </div>
            <div class="prelative"
                 v-if="imgSource.length > 0 && (imgSource.indexOf('placeholder6') === -1 || $store.state.showPlaceholders)">
              <img :alt="$store.state.brandName" class="tileImg" :src="imgSource"
                   :class="{withPlaceholder: imgSource.includes('placeholder'), forDrinks:fordrinks}"
                   >
<!--                   @click.stop="clickImage">-->
              <!--              <div class="stoerer abs" v-if="item.neu">NEU</div>-->
            </div>
          </div>

          <div style="" class="verticalFlex"
               :class="{withImage: imgSource.length > 0 && imgSource.indexOf('placeholder') === -1}">
            <!--                  right side-->

            <div class="dd-texts">
              <div class="d-flex">
                <div>
                  <span v-if="item.neu" class="stoerer mr-2">NEU</span>
                  <h3 class="itemTitle headColor d-inline hyphens" v-html="item.nameDE"></h3>
                  <span v-if="item.substances && item.substances.lAlk"><sup class="alk"
                                                                            :class="{bgLight:bgLight}">mit Alkohol</sup></span>
                </div>
                <div class="heart d-inline-block"
                     v-if="$store.state.enableFavs && (isFavorite || expanded)">
                  <v-btn class="rounded100" dark icon style="width: 35px; height: 35px; margin-top: -4px;"
                         @click.native.passive.stop="switchFavorite">
                    <v-icon medium color="red" v-if="isFavorite">mdi-heart</v-icon>
                    <v-icon medium color="#888888" v-else>mdi-heart-outline</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="fontColor textFont pt-2 limitedGrow">
                <div>
                  <div v-if="expanded" class="breakable" v-html="item.descriptionDE"></div>
                  <div v-else class="twoLiner">{{ item.descriptionDE | noHtml }}</div>
                  <div v-if="$store.state.enableBestand && $store.state.enableBestandanzeigeInItemList && item.bestand && item.bestand !== -1">
                    Bestand: {{item.bestand}}
                  </div>
                </div>
              </div>
              <div class="notAvailable pt-2" v-if="!buyable">
                <template v-if="item.redAvailabilityInfo">
                  <span>{{ item.redAvailabilityInfo }}</span>
                </template>
                <template v-else>
                  <span v-if="!item.buyable">Der Artikel ist nicht online bestellbar</span>
                  <span
                    v-else-if="$store.getters.inhouse && !item.buyableForInhouse">Der Artikel ist Inhouse nicht bestellbar</span>
                  <span
                    v-else-if="!$store.getters.inhouse && !!item.buyableForInhouse">Der Artikel ist nur Inhouse bestellbar</span>
                  <span v-else>Der Artikel ist nicht online bestellbar</span>
                  <!--                <span v-else>Der Artikel ist für das gewählte Abholdatum nicht verfügbar</span>-->
                  <!--                ({{ item.filteredByAvailability}})-->
                </template>
              </div>
            </div>

            <div style=" flex-grow:1"></div>

            <div class="dd-preise pt-3" v-if="item.sizes">
              <div class="d-flex" style="flex-direction: column;">
<!--                <template v-if="fordrinks">-->
                  <template>
                  <div>
                    <div v-if="hasReplaceArticle">
                      <div class="fontColor maxw preis" :class="{actualPrice: item.streichPreis }">
                        <span v-if="item.streichPreis">&#x2728;</span>{{ item | basePrice }}
                      </div>
                    </div>
                    <div v-else class="d-flex" style="line-height: 1.5em" v-for="size in item.sizes">
                      <div class="fontColor itemSubtitle mr-4 text-no-wrap" v-if="size.vol">{{ size.vol }}</div>
                      <div class="fontColor maxw preis" v-if="!$store.getters.hidePrices">{{ size.price | price(false) }}</div>
                    </div>
                    <div v-if="item.streichPreis"
                         class="streichPreisCrossed ml-3">
                      <div class="schraeger-text">
                        {{ item.streichPreis | price }}
                      </div>
                    </div>
                  </div>
                </template>
<!--                <template v-else>-->
<!--                  <div class="d-flex" v-if="!$store.getters.hidePrices">-->
<!--                    <div v-if="hasReplaceArticle">-->
<!--                      <div class="fontColor maxw preis" :class="{actualPrice: item.streichPreis }">-->
<!--                        <span v-if="item.streichPreis">&#x2728;</span>{{ item | basePrice }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div v-else class="fontColor preis">-->
<!--                      <span v-if="item.streichPreis">&#x2728;</span>{{ item.sizes[0].price | price(false) }}-->
<!--                    </div>-->
<!--                    <div v-if="item.streichPreis"-->
<!--                         class="streichPreisCrossed ml-3">-->
<!--                      <div class="schraeger-text">-->
<!--                        {{ item.streichPreis | price }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </template>-->
                <div class="ml-3 secondaryFontColor smallText" v-if="item.kilopreis">{{ item.kilopreis }}</div>
                <!--                    <v-icon class="myAccent">mdi-chevron-right</v-icon>-->
              </div>
            </div>


          </div>
        </div>

        <div class="prelative" style="max-height: 0">
          <!--          plusBox-->
          <div class="d-flex">
            <!--                    Priceline-->

            <div v-if="!item.section" style="flex-shrink: 0;">
              <!--                <div class="d-flex" v-if="item.sizes">-->
              <!--                    <template v-if="fordrinks">-->
              <!--                <div class="invisible">-->
              <!--                  <v-icon x-large class="myAccent">mdi-plus-box</v-icon>-->
              <!--                  &lt;!&ndash;                            <div v-if="hasReplaceArticle">&ndash;&gt;-->
              <!--                  &lt;!&ndash;                                <div class="fontColor maxw text-right"> {{item | basePrice}}</div>&ndash;&gt;-->
              <!--                  &lt;!&ndash;                            </div>&ndash;&gt;-->
              <!--                  &lt;!&ndash;                            <div v-else class="d-flex" style="line-height: 1.5em" v-for="size in item.sizes">&ndash;&gt;-->
              <!--                  &lt;!&ndash;                                <div class="fontColor itemSubtitle mr-2 text-no-wrap" v-if="size.vol">{{size.vol}}</div>&ndash;&gt;-->
              <!--                  &lt;!&ndash;                                <div class="fontColor maxw text-right">{{size.price | price}}</div>&ndash;&gt;-->
              <!--                  &lt;!&ndash;                            </div>&ndash;&gt;-->
              <!--                </div>-->
              <div class="plusBox" @click.passive.stop="clickItem(item)" v-if="buyable">
                <v-icon x-large class="myAccent" style="margin-bottom: 2px" v-if="expanded">mdi-close-box</v-icon>
                <v-icon x-large class="myAccent" v-else>mdi-plus-box</v-icon>
              </div>
              <!--                    </template>-->
              <!--                    <template v-else>-->
              <!--                        <v-icon x-large class="myAccent">mdi-plus-box</v-icon>-->
              <!--&lt;!&ndash;                        <div v-if="hasReplaceArticle">&ndash;&gt;-->
              <!--&lt;!&ndash;                            <div class="fontColor maxw text-right"> {{item | basePrice}}</div>&ndash;&gt;-->
              <!--&lt;!&ndash;                        </div>&ndash;&gt;-->
              <!--&lt;!&ndash;                        <div v-else class="fontColor "> {{item.sizes[0].price | price}}</div>&ndash;&gt;-->
              <!--                    </template>-->
              <!--                    <v-icon class="myAccent">mdi-chevron-right</v-icon>-->

            </div>
          </div>
        </div>


        <div v-if="expanded">
          <div v-if="item.gramm"
               class="d-flex align-center">
            <!--          || item.sizes && item.sizes.length === 1 && item.sizes[0].vol"-->
            <!--            <v-icon class="mr-1">mdi-weight-gram</v-icon>-->
            <!--            Gewicht:-->
            <span v-if="item.gram">{{ item.gramm }}g</span>
            <!--            <span>{{ item.sizes[0].vol }}</span>-->
          </div>
          <div v-if="item.cmRatio" class="d-flex align-center">
            <v-icon>mdi-corn</v-icon>
            Getreidemischverhältnis: {{ item.cmRatio }}
          </div>
          <div v-if="item.days && $store.state.showItemDaysAvailability" class="pt-2">
            <!--                        <v-icon :color="itemAvailable() === true ? 'green' : 'red'" small>mdi-circle</v-icon>&ndash;&gt;-->
            Verfügbarkeit: {{ item.days | displayDays }}
          </div>
        </div>

        <!--                text-truncate d-block-->
        <!--                <v-list-item-subtitle>{{item.descriptionDE}}</v-list-item-subtitle>-->
        <!--            </div>-->
      </v-list-item-content>


      <!--                    <v-list-item-icon>-->
      <!--                        <v-icon>mdi-heart</v-icon>-->
      <!--                    </v-list-item-icon>-->
    </v-list-item>
    <!--        <v-divider></v-divider>-->

    <div class="invisibleDetail" v-if="showItemDetail && currentItem.id">
      <div v-if="fordrinks">
        <DrinkItemDetail
          @wasAdded="showItemDetail = false"
          :add-directly="false"
          :itemId="currentItem.id"
        ></DrinkItemDetail>
      </div>
      <div v-else>
        <ItemDetail
          @wasAdded="showItemDetail = false"
          :add-directly="false"
          :itemId="currentItem.id"
        ></ItemDetail>
      </div>
    </div>
    <div class="fullImage superCenter" :class="{isMobile:isMobile}"
         v-if="fullImageSrc.length > 0"
         @click.passive.stop="fullImageSrc = ''">
      <img :src="fullImageSrc"
           class="rImg"
           :class="{doFade: fullImageSrc.length > 0}"
           :key="fullImageSrc"
           v-if="fullImageSrc.length > 0"
      >
      <div class="tip pointer">
        <div class="pt-1 pb-1">
          <v-icon big class="myWhite">mdi-close</v-icon>
        </div>
        <h3 style="color: white;">TAP TO CLOSE </h3>
      </div>
    </div>
  </div>


  <!--    Original Zeile eines Produktes von jetztessen.de-->
  <!--    <div class="itemsRow">-->
  <!--        <v-list-item-->
  <!--                :key="item.id"-->
  <!--                @click=""-->
  <!--        >-->
  <!--            <v-list-item-avatar tile :size="90">-->
  <!--                <v-img :src="imgSource"></v-img>-->
  <!--            </v-list-item-avatar>-->

  <!--            <v-list-item-content>-->
  <!--                <v-list-item-title v-text="item.nameDE"></v-list-item-title>-->
  <!--&lt;!&ndash;                <h3 class="text-none">{{item.nameDE}}</h3>&ndash;&gt;-->
  <!--                &lt;!&ndash;                <v-list-item-title v-text="news.title"></v-list-item-title>&ndash;&gt;-->
  <!--                <v-list-item-subtitle>{{item.descriptionDE}}</v-list-item-subtitle>-->
  <!--            </v-list-item-content>-->

  <!--            <v-list-item-action>-->
  <!--&lt;!&ndash;                <v-btn icon>&ndash;&gt;-->
  <!--                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>-->
  <!--&lt;!&ndash;                </v-btn>&ndash;&gt;-->
  <!--            </v-list-item-action>-->

  <!--&lt;!&ndash;                    <v-list-item-icon>&ndash;&gt;-->
  <!--&lt;!&ndash;                        <v-icon>mdi-heart</v-icon>&ndash;&gt;-->
  <!--&lt;!&ndash;                    </v-list-item-icon>&ndash;&gt;-->
  <!--        </v-list-item>-->
  <!--        <v-divider></v-divider>-->
  <!--    </div>-->
</template>

<script>
import {ebus} from '../vendor/ebus';
import store from '../store/store'
import * as util from "@/vendor/util";
import * as qconst from '../vendor/qconstants';
import * as itemUtil from '../vendor/itemUtil'
import ItemDetail from "../views/ItemDetail";
import DrinkItemDetail from "../views/DrinkItemDetail";
import DrinkCards from "./DrinkCards";
import {getCurrentDevice} from "@/vendor/breakpoints";
import {setGlobalKeyValue} from "@/util/globalState";
import {clearEvents, cloneMe} from "../vendor/util";

export default {
  name: 'ItemsRow',
  components: {DrinkCards, ItemDetail, DrinkItemDetail},
  props: {
    item: {
      type: Object,
    },
    expanded: {
      type: Boolean,
      default: false
    },
    fordrinks: {
      type: Boolean,
      default: false
    },
    isSection: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    bgLight: true,

    fullImageSrc: '',
    showItemDetail: false,
    currentItem: {},
    currentBusId: 0,

    isFavorite: false,
  }),
  computed: {
    isMobile() {
      return store.getters.deviceClass !== 'md';
    },
    buyable() {
      let a = (!('buyable' in this.item) || this.item.buyable) && this.item.withinOrderTimes;
      let b = store.getters.inhouse ? this.item.buyableForInhouse : this.item.buyableForTakeaway;
      return a & b;
    },
    orderingEnabled() {
      return !!store.getters.selectedStore.orderingEnabled;
    },
    hasReplaceArticle() {
      return !!itemUtil.findReplaceArticleStep(this.item);
    },
    imgSource() {
      let src = '';

      if (this.item.image && this.item.image.length > 0) {
        src = this.item.image;
      } else {
        src = require('@/assets/placeholder6-opti.png');
      }


      return src;
    },
    // hasDeepLink() {
    //     let link = this.news.link;
    //     return (link && link.indexOf('#') !== -1);
    // }
  },
  created() {
  },
  mounted() {
    this.showItemDetail = false;
    this.updateFavoriteIcon();
  },
  // activated() {
  //     this.showItemDetail = false;
  //     this.updateFavoriteIcon();
  // },
  destroyed() {
    this.showItemDetail = false;
  },
  methods: {
    clickImage() {
      if (!this.imgSource.includes('placeholder')) {
        this.fullImageSrc = this.imgSource;
      }
    },

    // init() {
    // },
    switchFavorite() {
      console.log('switchFavorite is Favorite = ' +
        this.isFavorite);

      let itemId = '' + this.item.id;
      if (this.isFavorite) {
        if (this.fordrinks) {
          store.commit('removeFavDrink', itemId);
        } else {
          store.commit('removeFavFood', itemId);
        }
        this.isFavorite = false;
      } else {
        let itemClone = util.cloneMe(this.item);
        let fav = {
          id: itemId,
          num: itemClone.num,
          posId: itemClone.posId,
          image: itemClone.image,
          nameToDisplay: itemClone.nameDE,
          extras: [],
          extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
          variantsSelected: [], //[{...},{...}]
          stylesSelected: [], //[{...},{...}]
          vol: '' + this.currentVol
        };
        // let size = itemClone.sizes[0];
        // if (this.currentVol.length > 0) {
        //     let relevantSize = this.findSizeByVol(itemClone.sizes, fav.vol);
        //     if (relevantSize) {
        //         size = relevantSize;
        //     }
        // }
        // if (!this.fillItemWithSelectedExtras(size, fav, itemClone)) {
        //     //do not add fav food if there the user needs to select options first
        //     return;
        // }
        if (this.fordrinks) {
          store.commit('addFavDrink', fav);
        } else {
          store.commit('addFavFood', fav);
        }

        this.isFavorite = true;
        // ebus.$emit('toast', ' wurde als Favorit gespeichert!');
        // ebus.$emit('toast', {
        //     msg: this.item.nameDE + ' wurde als Favorit gespeichert!',
        //     time: 2500
        // });
      }

      // ebus.$emit('favoritesUpdated');
      ebus.$emit('saveUserPreferences');
      setTimeout(() => {
        ebus.$emit('combineFavs');
        // ebus.$emit('favoritesUpdated');
      }, 100);//give saveUserSettings in App.vue time to update the localStorage
    },
    updateFavoriteIcon(preselect) {
      // let restId = store.getters.restId;

      if (this.item && this.item.id) {
        let isFav = false;
        if (this.fordrinks) {
          for (let fav of store.getters.favDrinks) {
            if (fav.id === this.item.id) {
              isFav = true;
              break;
            }
          }
          // if (store.getters.favFoods.length === 0) {
          let lsFavDrinks = this.$ls.get('favDrinks');
          if (lsFavDrinks) {
            let favDrinks = lsFavDrinks;
            for (let fav of favDrinks) {
              if (fav.id === this.item.id) {
                isFav = true;
                break;
              }
            }
          }
        } else {
          for (let fav of store.getters.favFoods) {
            if (fav.id === this.item.id) {
              isFav = true;
              break;
            }
          }
          // if (store.getters.favFoods.length === 0) {
          let lsFavFoods = this.$ls.get('favFoods');
          if (lsFavFoods) {
            let favFoods = lsFavFoods;
            for (let fav of favFoods) {
              if (fav.id === this.item.id) {
                isFav = true;
                break;
              }
            }
          }
        }
        this.isFavorite = isFav;
      } else {
        this.isFavorite = false;
      }

      // //preselect extras from cartItem or from favs
      // let variantsSelected = [];
      // let stylesSelected = [];
      // let cartItem = this.findCartItem();
      // if (cartItem) {
      //     variantsSelected = cartItem.variantsSelected;
      //     stylesSelected = cartItem.stylesSelected;
      // } else if ('extras' in this.item && this.isFavorite) {
      //     let favItem = this.findFavItem();
      //     if (!favItem) {
      //         return;
      //     }
      //     for (let styleSelected of favItem.stylesSelected) {
      //         stylesSelected.push(styleSelected);
      //     }
      //     for (let variantSelected of favItem.variantsSelected) {
      //         variantsSelected.push(variantSelected);
      //     }
      // }
      // if (preselect) {
      //     this.preselectExtras(variantsSelected, stylesSelected);
      // }
    },
    gotoItem(item) {
      if (item.section) {
        return;
      }
      if (this.fordrinks) {
        this.$router.push({name: 'Getraenk', params: {itemId: item.id}});
      } else {
        this.$router.push({name: 'Speise', params: {itemId: item.id}});
      }
    },
    clickBox(item, event) {
      if (item.section) {
        return;
      }
      if (store.getters.isKiosk && event) {
        if (item.buyable) {
          event.stopPropagation();
          this.clickItem(item);
        }
      }
    },
    clickItem(item) {
      console.log('click expand...');
      if (this.expanded) {
        console.log('extras are still expanded');
        this.$emit('close');
        return;
      }

      if (item.section) {
        return;
      }

      //if item can be added directly, do so, else gotoItem
      if (this.canAddDirectly(item)) {
        this.addDirectly(item);
      } else {

        if (store.getters.isKiosk) {
          if (!item.buyable) {
            return;
          }
          let itm = cloneMe(this.item);
          itm.itemType = this.fordrinks ? qconst.type$drinkOrder : qconst.type$foodOrder;
          setGlobalKeyValue('articleToShowInPopup', itm);
          this.$store.commit('showItemAdditionals', true);
          this.$store.dispatch('openMyPopup');
          ebus.$emit('itemAdditionalsWasUpdated');
          return;
        }

        if (getCurrentDevice() !== 'md' && qconst.useExtrasExpander) {
          this.$emit('expandExtrasForItem', util.cloneMe(this.item));
        } else {
          this.gotoItem(item);
        }
      }
    },
    addDirectly(item) {
      console.log('addDirectly ...');
      store.commit('itemForAddDirectly', util.cloneMe(item));
    },
    canAddDirectly(item) {
      try {
        if (store.getters.isKiosk) {
          return false;
        }
        if (item.sizes && item.sizes.length > 1) {
          return false;
        }
        if (item.extras) {
          if (item.extras.variants && item.extras.variants.length > 0) {
            return false;
          }

          //styles => fill extrasToDisplay and stylesSelected
          if (item.extras.styles && item.extras.styles.length > 0) {
            return false;
          }
        }
        return true;
      } catch (e) {
        console.log('error in canAddDirectly ' + e.message);
        return false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.headColor {
  //color: $heading-color;
}

.dd-texts {
  padding-right: 12px;
}

.dd-preise {
  margin-right: 50px;
}

.tileImgCol {
  flex-basis: 0;
  flex-grow: 0;

  &.withImage {
    flex-basis: 30%;
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 16px;
  }
}

.tileImg {
  border-radius: $box-border-radius;
  width: 100%;
  object-fit: cover;
  @include aspect(1, 1);
  //aspect-ratio: 1 / 1;

  &.forDrinks {
    //object-fit: contain;
  }

  &.withPlaceholder {
    //border-radius: 0;
  }
}

.verticalFlex {
  flex-basis: 100%;

  &.withImage {
    flex-basis: 70%;
  }
}


.heart {
  margin-top: -3px;
}

.nflex {
  flex: none;

  &.dc {
    display: contents;
  }
}

.alk {
  margin-left: 5px;
  //color: white;

  &.bgLight {
    color: black;
  }
}

.itemsRow ::v-deep .v-avatar {
  overflow: visible;
  transform: scale(1.15);
}

.invisibleDetail {
  max-height: 1px;
  width: 0;
  overflow: hidden;
  opacity: 0;
}

.plusBox {
  position: absolute;
  bottom: -7px;
  right: 6px;
  z-index: 2;
}

.preis {
  font-size: 1.15em;
}

.actualPrice {
  font-weight: bold;
}

.itemsRow {
  /*margin: 15px 0;*/
  /*margin: 5px 0;*/
  position: relative;
  padding: 0 2px;
  //color: $color-primary;

  //* {
  //  color: $color-primary;
  //}
}

.itemsRow ::v-deep .v-list-item {
  padding-left: 0;
  padding-right: 0;
}

//remove the hover effect
.itemsRow ::v-deep .v-list-item--link:hover:before, .itemsRow ::v-deep .v-list-item--link:focus:before {
  background-color: transparent;
}

/*<!--.itemsRow:not(.section) ::v-deep .v-list-item&#45;&#45;link:hover * {-->*/
/*<!--    color: $accent;-->*/
/*<!--}-->*/

.itemsRow.section * {
  cursor: initial;
}

.isection {
  /*padding-top: 10px;*/
  /*line-height: 1.1;*/

  h2 {
    padding-top: 25px;
  }

  .prefix {
    padding-top: 1px;
    padding-right: 5px;
  }
}

/*.isection ::v-deep b {*/
/*    font-weight: 700;*/
/*}*/

/*.itemsRow ::v-deep .v-list-item__title {*/
/*    font-size: 1em;*/
/*    font-weight: 700;*/
/*}*/

/*.itemsRow ::v-deep .v-btn__content {*/
/*    font-size: 1.2rem;*/
/*}*/

/*.itemsRow ::v-deep .headline {*/
/*    letter-spacing: 0.070rem !important;*/
/*}*/

/*.itemsRow ::v-deep .v-card__actions {*/
/*    position: absolute;*/
/*    bottom: 0;*/
/*    left: 0;*/
/*    width: 100%;*/
/*    padding-bottom: 0;*/
/*}*/

/*.itemsRow ::v-deep .v-icon {*/
/*    font-size: 25px;*/
/*}*/


</style>
